import _defineProperty from "/builds/aspendental/web/apps/aspendental-clearchoice-compare/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import React from 'react';
import { TAGTypography, TAGSvgIcon, TAGCarousel, Box, Container, Grid, useMediaQuery, useTheme } from '../..';
export var PatientReviews = function PatientReviews(_ref) {
  var backgroundColor = _ref.backgroundColor,
      _ref$fullWidth = _ref.fullWidth,
      fullWidth = _ref$fullWidth === void 0 ? true : _ref$fullWidth,
      reviews = _ref.reviews,
      showIcon = _ref.showIcon,
      title = _ref.title;
  var isDark = backgroundColor === 'dark';
  var mobileWidth = useMediaQuery('(max-width:600px)');
  var theme = useTheme();
  return React.createElement(Grid, {
    container: true,
    sx: fullWidth ? {
      backgroundColor: "backgrounds.".concat(backgroundColor)
    } : {}
  }, React.createElement(Container, {
    sx: _defineProperty({}, theme.breakpoints.down('sm'), {
      paddingLeft: '0',
      paddingRight: '0'
    })
  }, React.createElement(Grid, {
    item: true,
    sx: {
      bgcolor: "backgrounds.".concat(backgroundColor),
      padding: '50px 0'
    }
  }, React.createElement(Box, {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center"
  }, showIcon && React.createElement(TAGSvgIcon, {
    icon: "Quotes",
    size: 64
  }), React.createElement(TAGTypography, {
    color: isDark ? 'primary.light' : 'primary',
    variant: "h1",
    sx: {
      my: {
        md: '16px',
        sm: '24px',
        xs: '24px'
      },
      textAlign: 'center'
    }
  }, title)), React.createElement(TAGCarousel, {
    sx: {
      maxWidth: '100%',
      "& [data-swipeable='true']": {
        display: 'flex'
      }
    },
    arrows: !mobileWidth,
    peeking: mobileWidth
  }, reviews.map(function (_ref2, index) {
    var contentful_id = _ref2.contentful_id,
        description = _ref2.description,
        subText = _ref2.subText;
    return React.createElement(Box, {
      key: "".concat(contentful_id).concat(index),
      sx: {
        display: 'flex',
        flexDirection: 'column',
        padding: '20px',
        border: mobileWidth && backgroundColor === 'white' ? '1px solid #D6D9DA' : 'none',
        borderRadius: '8px',
        marginBottom: '32px',
        marginX: '16px',
        backgroundColor: {
          xs: 'backgrounds.white',
          md: "backgrounds.".concat(backgroundColor),
          lg: "backgrounds.".concat(backgroundColor)
        }
      }
    }, React.createElement(TAGTypography, {
      color: isDark ? 'text.light' : 'text.secondary',
      variant: "bodyLargeBook"
    }, description === null || description === void 0 ? void 0 : description.description), React.createElement(TAGTypography, {
      color: isDark ? 'text.light' : 'text.tertiary',
      variant: "bodySmallBook",
      sx: {
        paddingTop: {
          xs: '12px',
          md: '20px',
          lg: '20px'
        },
        marginBottom: 0
      }
    }, subText));
  })))));
};
export default PatientReviews;